<template lang="html">
  <section>
    <vue-dropzone 
        id="dropzone" 
        ref="dropzone" 
        :options="dropOptions" 
        @vdropzone-complete="afterComplete" 
        @vdropzone-removed-file="removeThisFile" 
    />
  </section>
</template>

<script> 
import vueDropzone from "vue2-dropzone"
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'uploadFile',
  props: ['uri', 'tok', 'table', 'id'],
  data: () => {
    return {
      document: {},
      token: '',
      url: '',
      table_name:'',
      table_id: '',
      dropOptions: {
        uploadMultiple: false,
        paramName: "document",
        acceptedFiles: 'image/*, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        maxFilesize: 5, // MB
        thumbnailWidth: 100,
        thumbnailHeight: 50,
        dictDefaultMessage: "<i class='fa fa-cloud-upload fa-5x'></i><br/>Drag and drop a file here<br/>or<br/><button type='button' class='btn btn-primary btn-sm'>Choose file</button>"
      }
    }
  },
  created(){
    showLoader()
    this.url = this.uri
    this.token = this.tok
    this.table_name = this.table
    this.table_id = this.id
    this.dropOptions.url = `${this.url}documents?token=${this.token}&table=${this.table_name}&table_id=${this.table_id}`
    hideLoader()
  },
  methods:{
    afterComplete(file) {
      if(file.accepted){
        let conv = {}
        let res = file.xhr.response
        conv = JSON.parse(res)
        //console.log(conv.data)
        let f = {
          document: {
            id: conv.data.id,
            table: conv.data.table,
            table_id: conv.data.table_id,
            path: conv.data.path,
            name: conv.data.name,
            type: conv.data.type
          }
        }
        //console.log(f)
        this.$emit('newfile', f)
        this.$refs.dropzone.removeAllFiles()
       }
     },
     removeThisFile(file) {
       //console.log(file)
     }
  },
  components: {vueDropzone}
}
</script>